import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

import { API_BASE_URL } from '../../config/api';

function RouteCreate({ onNavigate }) {
  const { token } = useAuth();
  
  const [name, setName] = useState('');
  const [journeyId, setJourneyId] = useState('');
  const [routeType, setRouteType] = useState('TRADITIONAL');
  const [description, setDescription] = useState('');
  
  const [journeys, setJourneys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJourneys = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/journeys`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (res.ok) {
          setJourneys(await res.json());
        }
      } catch (e) {
        console.error('Failed to fetch journeys', e);
      }
    };
    fetchJourneys();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Route name is required');
      return;
    }

    setLoading(true);
    setError(null);

    const payload = {
      name,
      journey_id: journeyId || null,
      route_type: routeType,
      description: description || null
    };

    try {
      const res = await fetch(`${API_BASE_URL}/routes/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        onNavigate('routes');
      } else {
        const errData = await res.json();
        setError(errData.detail || 'Failed to create route');
      }
    } catch (e) {
      setError('Network error. Failed to create route.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <h3 style={{ marginBottom: '24px' }}>Create New Route</h3>
      
      {error && (
        <div style={{ padding: '12px', background: '#FFEBEE', color: '#C62828', borderRadius: '6px', marginBottom: '20px' }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: 600 }}>Route Name *</label>
          <input 
            type="text" 
            className="input-field" 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
            placeholder="e.g. Traditional Kanwar Route 2026"
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: 600 }}>Route Type</label>
            <select 
              value={routeType} 
              onChange={(e) => setRouteType(e.target.value)}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', height: '40px' }}
            >
              <option value="TRADITIONAL">Traditional</option>
              <option value="VIP">VIP Route</option>
              <option value="EMERGENCY">Emergency Corridor</option>
            </select>
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: 600 }}>Associated Journey (Season)</label>
            <select 
              value={journeyId} 
              onChange={(e) => setJourneyId(e.target.value)}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', height: '40px' }}
            >
              <option value="">Independent (No Journey)</option>
              {journeys.map(j => (
                <option key={j.id} value={j.id}>{j.name}</option>
              ))}
            </select>
          </div>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: 600 }}>Description</label>
          <textarea 
            value={description} 
            onChange={(e) => setDescription(e.target.value)}
            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', minHeight: '100px' }}
            placeholder="Provide routing milestones, road conditions, etc."
          />
        </div>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button 
            type="button" 
            className="btn-outline" 
            onClick={() => onNavigate('routes')}
            disabled={loading}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="btn-primary"
            disabled={loading}
          >
            {loading ? 'Creating...' : 'Create Route'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default RouteCreate;
